import { Link } from "react-router-dom";
import { ProjectMedia } from "@/components/common/ProjectMedia";
import { TYPE_LABEL, STATUS_LABEL } from "@/data/site";

export const StatusTag = ({ status }) => (
  <span className={`label-mono inline-flex items-center gap-2 bg-canvas/85 px-2 py-1 ${status === "ongoing" ? "text-leaf" : "text-ink"}`}>
    <span className={`h-1.5 w-1.5 ${status === "ongoing" ? "animate-pulse bg-leaf" : "bg-ink"}`} aria-hidden />
    {STATUS_LABEL[status]}
  </span>
);

export const ProjectCard = ({ project: p }) => (
  <Link to={`/projects/${p.slug}`} className="group block" data-testid={`project-card-${p.slug}`}>
    <div className="relative">
      <ProjectMedia project={p} className="aspect-[4/3]" imgClassName="transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
      <span className="label-mono absolute left-3 top-3 bg-canvas/85 px-2 py-1 text-ink">{p.ref}</span>
      <span className="absolute right-3 top-3"><StatusTag status={p.status} /></span>
    </div>
    <div className="mt-5">
      <h3 className="relative inline-block font-display text-2xl font-bold uppercase leading-tight sm:text-3xl">
        {p.name}
        <span className="absolute -bottom-1 left-0 h-[2px] w-full origin-left scale-x-0 bg-brand transition-transform duration-500 ease-out group-hover:scale-x-100" aria-hidden />
      </h3>
      <p className="mt-3 text-sm text-steel">{p.location}</p>
      <p className="label-mono mt-2 text-steel">
        {TYPE_LABEL[p.type]}{p.units ? ` · ${p.units} units` : ""}
      </p>
    </div>
  </Link>
);
